export type { LemonActionableTooltipProps } from './LemonActionableTooltip'
export { LemonActionableTooltip } from './LemonActionableTooltip'
